import { Tag, ExternalLink } from 'lucide-react';
import styles from './SpecialOffersPage.module.css';

interface OfferCard {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  linkUrl: string;
  badge?: string;
}

const offers: OfferCard[] = [
  {
    id: 'veronica-miles',
    title: "Veronica Miles' Favorite Finds",
    description: "Discover the top health and wellness products handpicked by Veronica Miles. Exclusive selections for our Peapil Health community.",
    imageUrl: '/veronica-miles.jpg',
    linkUrl: 'https://veronicamilesfood.com',
    badge: 'Featured',
  },
  {
    id: 'glp1-weight-loss',
    title: 'GLP-1 Weight Loss',
    description: "Learn about GLP-1 medications and how they can support your weight loss journey. Get expert guidance and resources.",
    imageUrl: '/glp1-weight-loss.png',
    linkUrl: 'https://orderlymeds.com/simplestart/?_ef_transaction_id=&uid=1&oid=2&affid=1580',
    badge: 'Popular',
  },
  {
    id: 'peapil-publishing',
    title: '15% Off at Peapil Publishing',
    description: "Save 15% on all cookbooks and health guides at Peapil Publishing. Use your exclusive member discount today.",
    imageUrl: '/peapil-publishing.png',
    linkUrl: 'https://peapilpublishing.com/discount/15OFF345',
    badge: '15% Off',
  },
];

function OfferCardComponent({ offer }: { offer: OfferCard }) {
  return (
    <a 
      href={offer.linkUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      className={styles.card}
    >
      <div className={styles.imageWrapper}>
        <img 
          src={offer.imageUrl} 
          alt={offer.title}
          className={styles.image}
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/placeholder-offer.png';
          }}
        />
        {offer.badge && (
          <span className={styles.badge}>{offer.badge}</span>
        )}
      </div>
      <div className={styles.content}>
        <h3 className={styles.cardTitle}>{offer.title}</h3>
        <p className={styles.description}>{offer.description}</p>
        <span className={styles.learnMore}>
          Learn More
          <ExternalLink size={16} />
        </span>
      </div>
    </a>
  );
}

export default function SpecialOffersPage() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>
          <Tag size={28} />
          Special Offers
        </h1>
        <p className={styles.subtitle}>Exclusive deals and promotions for Peapil Health members</p>
      </header>

      <div className={styles.grid}>
        {offers.map((offer) => (
          <OfferCardComponent key={offer.id} offer={offer} />
        ))}
      </div>
    </div>
  );
}
